export const API_ERROR = "api_failed";

export const RFQ_LIST = "rfq_list";
export const RFQ_LIST_SUCCESS = "rfq_list_success";
export const Q_VENDORS_LIST = "q_vendors_list";
export const Q_VENDORS_LIST_SUCCESS = "q_vendors_success";

export const INPUT_CHANGEVALUE = "Q_input_ChangeValue";
export const RFQ_NO_SELECT_CHANGEVALUE = "Q_rfq_Select_ChangeValue";
export const SELECT_CHANGEVALUE = "Q_Select_ChangeValue";

export const RFQ_ROW_DATA = "Q_rfq_row_data";
export const RFQ_ROW_DATA_SUCCESS = "Q_rfq_row_data_success";
export const QITEM_REMOVE = "Qitem_remove";

export const ITEM_QTY_CHANGEVALUE = "item_qty_ChangeValue";
export const ITEM_UNIT_CHANGEVALUE = "item_unit_ChangeValue";
export const ITEM_PRICE_CHANGEVALUE = "item_price_ChangeValue";
export const ITEM_BASEPRICE_CHANGEVALUE = "item_baseprice_ChangeValue";
export const ITEM_DISC_PERCENT_CHANGEVALUE = "item_desc_percent_ChangeValue";
export const ITEM_TAX_CHANGEVALUE = "item_tax_ChangeValue";
export const ITEM_TAXTYPE_CHANGEVALUE = "item_taxtype_ChangeValue";
export const ITEM_GROSS_VAL_CHANGEVALUE = "item_grossVal_ChangeValue";

export const QUOTATION_ADD = "qoutation_add";
export const QUOTATION_LIST = "qoutation_list";
export const QUOTATION_LIST_SUCCESS = "qoutation_list_success";
export const TOGGLE_ITEM_MENU = "q_toggle_item_menu";

export const SET_PARAMS = "Q_set_params";
export const FILTER_INPUT_CHANGEVALUE = "pi_Filter_input_ChangeValue";
export const FILTER_SELECT_CHANGEVALUE = "pi_Filter_Select_ChangeValue";

export const Q_MODEL_LIST_OPEN = "q_listItem_model_open";
export const Q_MODEL_LIST_CLOSE = "q_listItem_model_close";

export const QOUTATION_DATA = "qoutation_data";
export const QOUTATION_DATA_SUCCESS = "qoutation_data_success";
export const LIST_LAYOUT = "Q_list_layout";

export const FILTERS_SHOW_RIGHT_SIDEBAR = "Q_filter_show_right_sidebar";
export const FILTERS_HIDE_RIGHT_SIDEBAR = "Q_filter_hide_right_sidebar";
export const CLEAR_FILTER = "Q_clear_filter";

export const RFQ_FILTERS_LIST = "Q_rfq_filter_list";
export const RFQ_FILTERS_LIST_SUCCESS = "Q_rfq_filter_list_success";

export const SRFQ_FILTERS_LIST = "Q_Srfq_filter_list";
export const SRFQ_FILTERS_LIST_SUCCESS = "Q_Srfq_filter_list_success";

export const MR_CODE_DETAILS = "Q_mr_code_details";
export const MR_CODE_DETAILS_SUCCESS = "Q_mr_code_details_Successful";

export const PI_CODE_DETAILS = "Q_pi_code_details";
export const PI_CODE_DETAILS_SUCCESS = "Q_pi_code_details_Successful";

export const MR_ITEM_IMAGES = "Q_mr_item_images";
export const MR_ITEM_IMAGES_SUCCESS = "Q_mr_item_images_Successful";
export const RFQ_MR_ITEM_IMAGES_MODEL_CLOSE = "Q_mr_item_images_model_close";
